<!-- <div id="heroCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel" > -->
<div id="heroCarousel" class="carousel slide carousel-fade" >
  <!-- <div class="carousel-indicators">
    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
  </div> -->

  <div class="carousel-inner">
    <div class="carousel-item active carousel-item-1">
      <div class="carousel-overlay"></div>
      <div class="company-logo" #companyLogo>
        <img src="assets/icons/hero_zumera_logo.gif" class="zumera_logo" alt="">
      </div>

      <div class="carousel-text position-absolute z-3 w-75 bottom-0 start-0 text-light ms-5 mb-5 ">
        <p>INNOVATION - PEOPLE - COMMUNITY </p>
        <h2>Creating innovative experiences <br> that improves the lives <br> of the people, and transform communities.</h2>
      </div>

      <div class=" position-absolute z-3 bottom-0 end-0 text-light ms-5 mb-5 location_container">
        <h2 class="location_sm">BENIN CITY</h2>
        <p class="text-center">EDO STATE, NIGERIA.</p>
      </div>
    </div>

    <!-- <div class="carousel-item carousel-item-3">
      <div class="carousel-overlay"></div>
      <div class="company-logo" #companyLogo>
        <img src="https://res.cloudinary.com/dv3rvc1by/image/upload/f_auto,q_auto/v1/zumera%20property/cdzbz8kpqngn87to88vh" class="zumera_logo" alt="">
      </div>
      <div class="carousel-text position-absolute z-3 w-75 bottom-0 start-0 text-light ms-5 mb-5  ">
        <p>TRANSFORMING COMMUNITIES</p>
        <h2>Building exceptional structures <br> that unlock opportunities <br>and transform communities.</h2>
      </div>
    </div> -->



    
  </div>

</div>